import React from "react";
import OrganizationUsersIndexPage from "pages/_common/organization/OrganizationUsersIndexPage";
import { Route, Switch } from "react-router-dom";
import OrganizationUserCreateEditPage from "pages/_common/organization/OrganizationUserCreateEditPage";

const OrganizationUsersRouter = () => {
  return (
    <Switch>
      <Route exact path="/organizations/:organization_id/users" component={OrganizationUsersIndexPage} />
      <Route path="/organizations/:organization_id/users/create" component={OrganizationUserCreateEditPage} />
      <Route path="/organizations/:organization_id/users/:user_id/edit" component={OrganizationUserCreateEditPage} />
    </Switch>
  );
};

export default OrganizationUsersRouter;
